import React, { useEffect } from 'react';

const Efectos = props => {
    const elementInView = (el, dividend = 1) => {
        const elementTop = el.getBoundingClientRect().top;
        return (
            elementTop <=
            (window.innerHeight || document.documentElement.clientHeight) / dividend
        );
    };
  
    const elementOutofView = (el) => {
        const elementTop = el.getBoundingClientRect().top;
        return (
            elementTop > (window.innerHeight || document.documentElement.clientHeight)
        );
    };
  
    const displayScrollElement = (element) => {
        element.classList.add("scrolled");
    };
  
    const hideScrollElement = (element) => {
        element.classList.remove("scrolled");
    };
  
    const handleScrollAnimation = () => {
        const scrollElements = document.querySelectorAll(".js-scroll");
  
        scrollElements.forEach((el) => {
            if (elementInView(el, 1.25)) {
                displayScrollElement(el);
            } else if (elementOutofView(el)) {
                hideScrollElement(el)
            }
        })
    }
    
    useEffect(() => {
        if (props.activado) {
            handleScrollAnimation();
        } else {
            window.addEventListener("scroll", () => { 
                handleScrollAnimation();
            });
        }
    },[]);


    return (
        <div>
            {props.children}
        </div>
    );
};

export default Efectos;